import React, { useState } from 'react';
import { Input, Button } from '@crisellevaldez/speculo-ui';
import { Search, RotateCw } from 'lucide-react';
import { EngageFilterModal } from './EngageFilterModal';
import { FilterButton } from '../../common/FilterButton';

interface EngageTableHeaderProps {
  searchQuery: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRefresh: () => Promise<void>;
  onFilter: (filters: {
    status: string[];
    subType: string[];
    dateRange: { startDate: Date | null; endDate: Date | null };
  }) => void;
  isLoading: boolean;
  totalFlows: number;
}

export const EngageTableHeader: React.FC<EngageTableHeaderProps> = ({
  searchQuery,
  onSearchChange,
  onRefresh,
  onFilter,
  isLoading,
}) => {
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [activeFilters, setActiveFilters] = useState<{
    status: string[];
    subType: string[];
    dateRange: { startDate: Date | null; endDate: Date | null };
  }>({
    status: [],
    subType: [],
    dateRange: { startDate: null, endDate: null },
  });

  const getActiveFilterCount = () => {
    let count = 0;
    if (activeFilters.status.length > 0) count++;
    if (activeFilters.subType.length > 0) count++;
    if (activeFilters.dateRange.startDate && activeFilters.dateRange.endDate) count++;
    return count;
  };

  const handleFilter = (filters: typeof activeFilters) => {
    setActiveFilters(filters);
    onFilter(filters);
    setIsFilterModalOpen(false);
  };

  return (
    <>
      <div className="flex flex-col sm:flex-row items-center gap-2">
        <div className="w-full sm:flex-1">
          <Input
            placeholder="Search by name..."
            startIcon={<Search className="text-gray-400" size={20} />}
            value={searchQuery}
            onChange={onSearchChange}
            className="w-full"
          />
        </div>
        <div className="flex gap-2 w-full sm:w-auto">
          <FilterButton
            onClick={() => setIsFilterModalOpen(true)}
            activeCount={getActiveFilterCount()}
            className="h-9 flex-1 sm:w-[140px] justify-center"
            hideLabelOnMobile
          />
          <Button
            variant="secondary"
            size="sm"
            className="p-2 justify-center h-9"
            onClick={() => {
              // Reset local filter state
              setActiveFilters({
                status: [],
                subType: [],
                dateRange: { startDate: null, endDate: null },
              });
              onRefresh();
            }}
            disabled={isLoading}
          >
            <RotateCw className={`h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
          </Button>
        </div>
      </div>

      <EngageFilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        onFilter={handleFilter}
        initialFilters={activeFilters}
      />
    </>
  );
};
